import { defineFilters, enumOne, enumOrAny, text, type FilterOption } from '@/components/kit/filters'
import { UserRole, UserSortField } from '@/types/user'

const ROLE_OPTIONS: FilterOption<UserRole>[] = [
    { value: UserRole.User, label: 'User' },
    { value: UserRole.Sponsor, label: 'Sponsor' },
    { value: UserRole.Admin, label: 'Admin' }
]

export const USER_SORT_OPTIONS: FilterOption<UserSortField>[] = [
    { value: UserSortField.Xp, label: 'XP' },
    { value: UserSortField.CreatedAt, label: 'Created' },
    { value: UserSortField.UpdatedAt, label: 'Updated' },
    { value: UserSortField.Email, label: 'Email' }
]

const ORDER_OPTIONS: FilterOption<'asc' | 'desc'>[] = [
    { value: 'desc', label: 'Descending' },
    { value: 'asc', label: 'Ascending' }
]

export const userFilters = defineFilters(
    {
        search: text({ label: 'Search' }),
        role: enumOrAny(ROLE_OPTIONS, { label: 'Role' }),
        sortBy: enumOne(USER_SORT_OPTIONS, UserSortField.Xp, { label: 'Sort' }),
        sortOrder: enumOne(ORDER_OPTIONS, 'desc', { label: 'Order' })
    },
    { defaultLimit: 25 }
)

export type UserSearch = ReturnType<typeof userFilters.parse>
